// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"PZ-z","dimensionLabel":"QZ-z","styleChooserControlWrapper":"RZ-z","styleChooserControl":"SZ-z","disabled":"TZ-z","giftCard":"UZ-z","styleChooserText":"VZ-z"};